import React from 'react'
import classNames from 'classnames'
import { compose } from 'recompose'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.min.css'

const TimeInput = (props) => {
  const { label, placeHolder, require, editable, dateFormat='HH:mm', input, specialOnChange, meta: { touched, error } } = props
  return (
    <div className='fieldRow'>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`${classNames('fieldInput', { error: touched && error })} ${editable!==false?'editableDateInput':''}`}>
        <DatePicker 
          className='dateInput'
          selected={input.value}
          onChange={date => {
            input.onChange(date)
            if (specialOnChange) {
              specialOnChange(date, input.value)
            }
          }}
          showTimeSelect
          showTimeSelectOnly
          dateFormat={dateFormat}
          disabled={editable === false}
          placeholder={placeHolder}
        />
      </div>
    </div>
  )
}

export default compose()(TimeInput)